import Image from './Image';
import { ImageProps, ImageValueProps } from './types';

export type { ImageProps, ImageValueProps };
export default Image;
